import { createElement, type FC, Suspense } from 'react'
import type { CurzonGridColumn } from '@/features/grid/grid.types'
import { GridTypes } from '@/features/grid/grid.types'

export const GridElementsComponent: FC<CurzonGridColumn> = props => {
    if (props.elements && props.elements.length > 0) {
        return (
            <>
                {props.elements.map(
                    (element, index) =>
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- returning a component
                        element?.type &&
                        GridTypes[element.type] &&
                        createElement(
                            Suspense,
                            { key: 'suspense-' + index },
                            createElement(GridTypes[element.type], {
                                key: 'grid-element-' + index,
                                ...element,
                                additionalData: props.additionalData,
                            })
                        )
                )}
            </>
        )
    }
    return null
}
